// services/axios.ts
import axios from "axios";
import Cookies from "js-cookie";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_FRONTEND_URL,
});

// Request interceptor to set headers
axiosInstance.interceptors.request.use((config) => {
  const token = Cookies.get("token");

  if (!config.headers) {
    config.headers = {};
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  config.headers["Accept"] = "application/json";

  return config;
});

export default axiosInstance;
